import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AuthLayout from '../shared/AuthLayout';
import iconImage from '../../Assets/Light mode.png';
import bIconImage from '../../Assets/Light mode1.png';

const AccountOption = ({ onClick, icon, title, description }) => (
  <Button
    onClick={onClick}
    sx={{
      width: '100%',
      p: 0,
      borderRadius: '20px',
      textTransform: 'none',
      mb: 2,
      '&:hover .arrow-icon': { opacity: 1, transform: 'translateX(0)' },
    }}
  >
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        p: { xs: 2, sm: 2.5 },
        borderRadius: '20px',
        border: '1px solid',
        borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)',
        transition: 'box-shadow 0.2s ease-in-out',
        '&:hover': { boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.12)' },
      })}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box component="img" src={icon} alt="" aria-hidden="true" sx={{ width: 36, height: 36 }} />
        <Box sx={{ textAlign: 'left' }}>
          <Typography sx={{ fontWeight: 600, fontSize: { xs: 15, md: 16.5 }, color: 'text.primary' }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: { xs: 12.5, md: 13.5 }, color: 'text.secondary' }}>
            {description}
          </Typography>
        </Box>
      </Box>
      <Box
        className="arrow-icon"
        sx={{
          display: 'flex',
          color: 'primary.main',
          opacity: 0,
          transform: 'translateX(-4px)',
          transition: 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out',
        }}
      >
        <ArrowForwardIcon />
      </Box>
    </Box>
  </Button>
);

function Welcome() {
  const navigate = useNavigate();
  const handleSubmit = () => {
    navigate('/SignupPage');
  };

  return (
    <AuthLayout
      heading="Welcome"
      subheading="To begin this journey, tell us what type of account you'd be opening."
      footerPrompt="Already have an account?"
      footerLinkLabel="Log in"
      footerLinkTo="/login"
    >
      <AccountOption
        onClick={handleSubmit}
        icon={iconImage}
        title="Individual"
        description="Personal account to manage all your bills."
      />
      <AccountOption
        onClick={handleSubmit}
        icon={bIconImage}
        title="Business"
        description="Business account to manage all your company bills."
      />
    </AuthLayout>
  );
}

export default Welcome;
